import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  IDisallowedTimeRange,
  IRuleScopePickerOptions,
  describeRangeSchedule,
  isOvernightRange,
  ruleChipTitles,
  validateRange,
} from '../types';

/**
 * Compact rule list — column 2 of the three-panel editor.
 */
@Component({
  selector: 'blackout-hours-rules-list',
  templateUrl: './blackout-hours-rules-list.component.html',
  styleUrls: ['./blackout-hours-rules-list.component.scss'],
})
export class BlackoutHoursRulesListComponent implements OnChanges {

  @Input() ranges: IDisallowedTimeRange[] = [];
  @Input() selectedIndex: number | null = null;
  @Input() disabled: boolean = false;
  @Input() scopePickerOptions: IRuleScopePickerOptions | null = null;

  @Output() selectedIndexChange = new EventEmitter<number | null>();
  @Output() duplicateRule = new EventEmitter<number>();
  @Output() revokeRule = new EventEmitter<number>();

  /** One title per rule, numbered where titles repeat. */
  chipTitles: string[] = [];
  isOvernightRange = isOvernightRange;
  validateRange = validateRange;

  ngOnChanges(): void {
    this.chipTitles = ruleChipTitles(this.ranges);
  }

  scheduleSummary(range: IDisallowedTimeRange): string {
    return describeRangeSchedule(range, this.scopePickerOptions);
  }

  isAllowAllDay(range: IDisallowedTimeRange): boolean {
    return Number(range.is_allow_all_day) === 1;
  }

  isFullDayBlackout(range: IDisallowedTimeRange): boolean {
    if (this.isAllowAllDay(range)) return false;
    if (!range.time_start || !range.time_end) return true;
    return range.time_start === range.time_end;
  }

  selectRule(index: number) {
    if (this.disabled) return;
    this.selectedIndexChange.emit(index);
  }

  onDuplicate(event: Event, index: number) {
    event.stopPropagation();
    if (this.disabled) return;
    this.duplicateRule.emit(index);
  }

  onRevoke(event: Event, index: number) {
    event.stopPropagation();
    if (this.disabled) return;
    this.revokeRule.emit(index);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
